import React from 'react';

import styles from './LeagueTable.module.css';
import { useParams } from 'react-router-dom';
import { getPublicLeagueData } from '../../api/getPublicLeagueData';

import LeagueScoreTable from '../ScoreBoard/LeagueScoreTable/LeagueScoreTable';
import LeagueGoalsKingTable from '../ScoreBoard/LeagueGoalsKingTable/LeagueGoalsKingTable';
import LeagueAssistsKingTable from '../ScoreBoard/LeagueAssistsKingTable/LeagueAssistsKingTable';
import LeagueFairTeamsTable from '../ScoreBoard/LeagueFairTeamsTable/LeagueFairTeamsTable';

import shareIcon from './../../graphics/icons/share-30.svg';

function LeagueTable() {
  const { leagueId } = useParams();
  const [leagueInfo, setLeagueInfo] = React.useState(null);

  const sharePublicLeagueTableLink = `whatsapp://send?text=צפו בתוצאות הליגה שלי >>> ${window.location.origin}/leagues-score/${leagueId}`;

  const isShow = leagueInfo?.is_public;

   React.useEffect(() => {
     getPublicLeagueData(leagueId).then(data => {
       setLeagueInfo(data);
     });
   }, [leagueId]);

  return (
    <div className={styles.scoreBoard}>
      {leagueInfo && !leagueInfo.is_public && (
        <div className={styles.msgWrapper}>
          <div className={styles.msgBg}></div>
          <div className={styles.msgMsg}>{leagueInfo?.announcement}</div>
        </div>
      )}

      {leagueInfo && (
        <div className={styles.header}>
          <div>
            <div>תוצאות ליגות {leagueInfo.name} </div>
            <div className={styles.city}>בעיר {leagueInfo.city_name}</div>
          </div>
          <div className={styles.share}>
            <a
              href={sharePublicLeagueTableLink}
              data-action="share/whatsapp/share"
            >
              <img className={styles.edit} src={shareIcon} alt="שיתוף" />
            </a>
          </div>
        </div>
      )}

      {isShow && (
        <div className={styles.tables}>
          <div className={styles.groupsTable}>
            <LeagueScoreTable />
          </div>

          <div className={styles.secondery}>
            <div className={styles.goalsTable}>
              <LeagueGoalsKingTable />
            </div>
            <div className={styles.assistsTable}>
              <LeagueAssistsKingTable />
            </div>
            <div className={styles.fairsTable}>
              <LeagueFairTeamsTable />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

LeagueTable.propTypes = {};

export default LeagueTable;
